import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { CatalogPeriod } from "@/constants/sparxsCatalogFilters";
import { DEFAULT_PERIOD } from "@/constants/sparxsCatalogFilters";
import { clearSparxsCatalogFiltersToDefaults } from "@/store/statistics/sparxsCatalogFiltersActions";

const periodFilterSlice = createSlice({
  name: "periodFilter",
  initialState: DEFAULT_PERIOD,
  reducers: {
    updatePeriod: (_, action: PayloadAction<CatalogPeriod>) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(clearSparxsCatalogFiltersToDefaults, () => DEFAULT_PERIOD);
  },
});

export const { updatePeriod } = periodFilterSlice.actions;
export default periodFilterSlice.reducer;
